import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';

import { updateBlacklistEndDate } from 'features/communicationManagement';
import DateInput from 'components/DateInput';
import Field from 'components/Field';
import styles from './PersonalisedMenteeEmailersTimeInput.module.scss';

export default function PersonalisedMenteeEmailersTimeInput({
  pauseStartDate,
  handlePauseStartDateChange,
  pauseEndDate,
  handlePauseEndDateChange,
  inputErrors,
}) {
  const handlePauseDate = useCallback(
    (date) => {
      handlePauseStartDateChange(new Date(date).toISOString());
    },
    [handlePauseStartDateChange]
  );

  const handleResumeDate = useCallback(
    (date) => {
      handlePauseEndDateChange(new Date(date).toISOString());
    },
    [handlePauseEndDateChange]
  );

  const handleInfiniteBlock = useCallback(() => {
    updateBlacklistEndDate(handlePauseEndDateChange);
  }, [handlePauseEndDateChange]);

  return (
    <Field className={classNames(styles.root, 'm-t-m')}>
      <Field
        label="Pause from"
        className={classNames(styles.header, 'm-t-m')}
        name="start_date"
        prefixName={false}
        clientErrors={inputErrors}
      >
        <div className={styles.fieldEach}>
          <DateInput
            className={styles.dateInput}
            value={new Date(pauseStartDate).getTime()}
            onChange={handlePauseDate}
            placement="top"
          />
        </div>
      </Field>
      <Field
        label="Resume from"
        className={styles.header}
        name="end_date"
        prefixName={false}
        clientErrors={inputErrors}
      >
        <div className={classNames(styles.inputField, 'm-t-xxs', 'm-b-xs')}>
          <div className={styles.fieldEach}>
            <DateInput
              className={styles.dateInput}
              value={new Date(pauseEndDate).getTime()}
              onChange={handleResumeDate}
              placement="top"
            />
          </div>
          <Tappable
            className={classNames(styles.blockAction, 'm-l-xs')}
            onClick={handleInfiniteBlock}
          >
            Block indefinitely
          </Tappable>
        </div>
      </Field>
    </Field>
  );
}
